import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { Loading } from '../../../../styles/components/form/Loading';
import { Button } from '../../../../styles/components/form/Button';

const FormButton = ({ loading, title, type, onClick, classes }) => {
      return (
            <>
                  <Form.Group as={Col} lg={12} className={'text-center pt-2'}>
                        <Button
                              type={type || 'submit'}
                              className={classes}
                              onClick={onClick}
                        >
                              {title || 'Submit'}
                              {loading && <Loading />}
                        </Button>
                  </Form.Group>
            </>
      );
};

export default FormButton;
